import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26467e9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Tipo da chave PIX:")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Celular")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("CNPJ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("e-mail")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Chave Aleatória")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Auto ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Correção de Erro")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Baixo (7%)")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Medio (15%)")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Alto (25%)")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Muito Alto (30%)")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("QR-Code")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Carrinho")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("EnviePix")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Limpar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_base_layout = _resolveComponent("base-layout")!

  return (_openBlock(), _createBlock(_component_base_layout, {
    "show-back-arrow": "true",
    "page-title": "QR-Code PIX",
    "page-default-back-link": "/frontpage"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ion_select, {
            placeholder: "Tipo da chave",
            modelValue: _ctx.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "telefone" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "cpf" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "cnpj" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "email" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "chave" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_input, {
            modelValue: _ctx.key,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.key) = $event)),
            placeholder: "Chave Pix",
            onChange: _ctx.parseKey
          }, null, 8, ["modelValue", "onChange"]),
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_ion_checkbox, { checked: _ctx.autoCheck }, null, 8, ["checked"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_input, {
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
            placeholder: "Nome do Beneficiário",
            color: _ctx.nameColor,
            type: "text"
          }, null, 8, ["modelValue", "color"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_input, {
            modelValue: _ctx.city,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.city) = $event)),
            placeholder: "Cidade da Agência",
            color: _ctx.cityColor,
            type: "text"
          }, null, 8, ["modelValue", "color"]),
          _createVNode(_component_ion_input, {
            modelValue: _ctx.ammount,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ammount) = $event)),
            placeholder: "Valor (R$)",
            type: "text"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_ion_select, {
            placeholder: "Tipo",
            modelValue: _ctx.fec,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fec) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "L" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "M" }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "Q" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "H" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            size: "small",
            onClick: _ctx.generate,
            disabled: !_ctx.itsOkToGenerate
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_ion_button, {
            size: "small",
            color: "success",
            onClick: _ctx.doCar,
            disabled: _ctx.qrcode == '' || _ctx.canCar==false
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_ion_button, {
            size: "small",
            color: "medium",
            onClick: _ctx.loadTest
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ion_button, {
            size: "small",
            onClick: _ctx.clear
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { class: "ion" }, {
        default: _withCtx(() => [
          (_ctx.qrcode!='')
            ? (_openBlock(), _createBlock(_component_ion_img, {
                key: 0,
                "router-link": "/car",
                src: _ctx.qrcode,
                width: "150",
                height: "150",
                alt: "qr-code"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, { class: "minor" }, {
            default: _withCtx(() => [
              _createTextVNode(" Lat: " + _toDisplayString(_ctx.location.latitude) + " Long:" + _toDisplayString(_ctx.location.longitude) + " Acc:" + _toDisplayString(_ctx.location.accuracy), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}